module.exports = __webpack_public_path__ + "static/media/jaysonPharmaceuticals.25a3932a.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/sponsors/jaysonPharmaceuticals.png
// module id = 1145
// module chunks = 0